// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"e_si","wrapperDark":"e_ti","wrapperLight":"e_ui","wrapperClosed":"e_vi","html":"e_wi"};